import React, { useState } from "react";
import classnames from "classnames";
import _ from "lodash";

import "./index.css";

const user_icon = require("../../../assets/media/user.png");

const InviteUsersToReview = ({ brandname, users, onInvite }) => {
  const [selected, setSelected] = useState([]);

  const onToggleSelect = (userId) => () => {
    setSelected(_.xor(selected, [userId]));
  };

  const onSelectAll = () => {
    setSelected(users.map((u) => u.id));
  };

  return (
    <div
      className="modal fade invite-users-to-review"
      id="invite_users_to_review"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-default-fadein"
      aria-hidden="true"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content invite-users-to-review-content">
          <div className="modal-body pb-1 invite-users-to-review-body">
            <div className="row">
              <div className="col col-md-7">
                <h4>Invite members to review {brandname}</h4>
                <div className="row user-item">
                  <div className="col col-3">Profile</div>
                  <div className="col col-6 user-item-name">Name</div>
                  <div className="col col-3">Select</div>
                </div>
                {users.map((user,index) => (
                  <div key={index} className="row user-item">
                    <div className="col col-3">
                      <img
                        src={user.avatar_url || user_icon}
                        className="avatar"
                        alt="icon"
                      />
                    </div>
                    <div className="col col-6 user-item-name">
                      {user.firstname}
                    </div>
                    <div className="col col-3">
                      <div
                        className={classnames("circle", {
                          selected: selected.includes(user.id),
                        })}
                        onClick={onToggleSelect(user.id)}
                      />
                    </div>
                  </div>
                ))}
              </div>
              <div className="col col-md-5">
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <p className="mt-5">
                  Users can be invited once added as a community user and if
                  they haven’t reviewed before.
                </p>
                <div className="buttons-container">
                  <button
                    type="button"
                    className="btn select-all"
                    onClick={onSelectAll}
                  >
                    Select all
                  </button>
                  <button
                    type="button"
                    className="btn invite-selected"
                    data-toggle="modal"
                    data-target="#invite_users_to_review"
                    onClick={() => onInvite(selected)}
                  >
                    Invite selected
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteUsersToReview;



// WEBPACK FOOTER //
// ./src/screens/BespokeReviews/InviteUsersToReview/index.js